
define('text!meeting-modal/calendar-plugins/calendar-plugins.html',[],function () { return '<div class="plugin-links" data-bind="bindHtml: installCalendarHtml()"></div>\n';});

